module.exports = __webpack_public_path__ + "img/goldregen-2020-084.e5373598.jpg";